// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Ebrn","content":"LayoutSettings_content__1bQn5"};